(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class HeroHeader {
    constructor() {
      this.headerWrapper  = document.querySelector('.header-wrapper--hero');
      if (!this.headerWrapper) return;

      this.sectionHeader  = document.querySelector('.section-header');
      this.heroLogo       = document.querySelector('.header-hero-logo');
      this.firstSection   = document.querySelector('.shopify-section:not(.shopify-section-group-header-group)');
      this.stickyHeaderEl = document.querySelector('sticky-header');

      this.threshold  = 80;
      this.isScrolled = false;
      this.ticking    = false;
      this._deltaX    = 0;
      this._deltaY    = -120;
      this._scale     = 0.35;

      // Keep bound handlers so we can remove them on destroy
      this._onScroll = () => {
        if (!this.ticking) {
          requestAnimationFrame(() => { this.update(); this.ticking = false; });
          this.ticking = true;
        }
      };
      this._onResize = () => {
        if (this.heroLogo) this.heroLogo.classList.remove('header-hero-logo--ready');
        this.applyOverlap();
        requestAnimationFrame(() => this.initHeroLogo());
      };

      this.setup();
    }

    setup() {
      if (this.sectionHeader) {
        this.sectionHeader.classList.add('section-header--hero', 'shopify-section-header-sticky');
      }
      if (this.stickyHeaderEl) {
        this.stickyHeaderEl.headerIsAlwaysSticky = true;
      }

      this.applyOverlap();
      this.initHeroLogo();

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    destroy() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    applyOverlap() {
      if (!this.firstSection || !this.sectionHeader) return;
      this.firstSection.style.marginTop = `-${this.sectionHeader.offsetHeight}px`;
    }

    initHeroLogo() {
      if (!this.heroLogo || !this.sectionHeader) return;

      const navH = this.sectionHeader.offsetHeight;
      const gap  = window.innerWidth < 750 ? 28 : 44;

      // Set initial fixed position (no transition yet)
      this.heroLogo.style.top           = `${navH + gap}px`;
      this.heroLogo.style.left          = '50%';
      this.heroLogo.style.transform     = 'translateX(-50%)';
      this.heroLogo.style.opacity       = '1';
      this.heroLogo.style.pointerEvents = 'all';

      const measureTargets = () => {
        const navLogoEl = this.headerWrapper.querySelector('.header__heading-logo-wrapper') ||
                          this.headerWrapper.querySelector('.header__heading-link');
        if (!navLogoEl) return;

        const navRect  = navLogoEl.getBoundingClientRect();
        const heroRect = this.heroLogo.getBoundingClientRect();
        if (heroRect.width === 0) return;

        this._deltaX = (navRect.left + navRect.width  / 2) - (heroRect.left + heroRect.width  / 2);
        this._deltaY = (navRect.top  + navRect.height / 2) - (heroRect.top  + heroRect.height / 2);
        this._scale  = navRect.width > 0 ? navRect.width / heroRect.width : 0.35;

        // Enable transitions only after position is established
        requestAnimationFrame(() => {
          this.heroLogo.classList.add('header-hero-logo--ready');
          this.update();
        });
      };

      requestAnimationFrame(() => {
        const img = this.heroLogo.querySelector('img');
        if (img && !img.complete) {
          img.addEventListener('load', measureTargets, { once: true });
        } else {
          measureTargets();
        }
      });
    }

    update() {
      const isScrolled = window.pageYOffset >= this.threshold;

      if (isScrolled !== this.isScrolled) {
        this.isScrolled = isScrolled;
        this.headerWrapper.classList.toggle('header-wrapper--scrolled', isScrolled);
      }

      if (!this.heroLogo) return;

      if (isScrolled) {
        this.heroLogo.style.transform     = `translateX(calc(-50% + ${this._deltaX}px)) translateY(${this._deltaY}px) scale(${this._scale})`;
        this.heroLogo.style.opacity       = '0';
        this.heroLogo.style.pointerEvents = 'none';
      } else {
        this.heroLogo.style.transform     = 'translateX(-50%)';
        this.heroLogo.style.opacity       = '1';
        this.heroLogo.style.pointerEvents = 'all';
      }
    }
  }

  function initHeroHeader() {
    if (window.__heroHeader) window.__heroHeader.destroy();
    window.__heroHeader = new HeroHeader();
  }

  document.addEventListener('DOMContentLoaded', initHeroHeader);

  // Re-initialize when Shopify theme editor reloads the section (e.g. logo width change)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.header-wrapper--hero')) initHeroHeader();
  });

  } catch(e) { console.error(e); }
})();
})();
